/** Faixas alinhadas ao scoring v2.2 (docs/sistema-scoring.md). */
export function scoreToClassification(score) {
  if (score == null || score < 0) return null;
  if (score >= 76) return "EXCEPCIONAL";
  if (score >= 66) return "PROVÁVEL";
  if (score >= 41) return "POSSÍVEL";
  if (score >= 11) return "REMOTO";
  return "INAPTO";
}

export function getScoreBadgeStyles(score) {
  if (score == null || score < 0) {
    return {
      classification: null,
      colorClass: "bg-gray-100 text-gray-600 border-gray-300",
      bgClass: "bg-gray-50",
    };
  }

  const classification = scoreToClassification(score);
  switch (classification) {
    case "EXCEPCIONAL":
      return {
        classification,
        colorClass: "bg-purple-100 text-purple-800 border-purple-300",
        bgClass: "bg-purple-50",
      };
    case "PROVÁVEL":
      return {
        classification,
        colorClass: "bg-green-100 text-green-800 border-green-300",
        bgClass: "bg-green-50",
      };
    case "POSSÍVEL":
      return {
        classification,
        colorClass: "bg-yellow-100 text-yellow-800 border-yellow-300",
        bgClass: "bg-yellow-50",
      };
    case "REMOTO":
      return {
        classification,
        colorClass: "bg-orange-100 text-orange-800 border-orange-300",
        bgClass: "bg-orange-50",
      };
    case "INAPTO":
    default:
      return {
        classification: classification || "INAPTO",
        colorClass: "bg-red-100 text-red-800 border-red-300",
        bgClass: "bg-red-50",
      };
  }
}
